// extracted by mini-css-extract-plugin
export default {"btn_link":"style_btn_link__Dn9mb"};